import { useIsFirstTimeLogin } from '../hooks/use-is-first-time-login'
import { StepBadge } from './StepBadge'

interface FirstTimeStepBadgeProps {
  step: number
}

/**
 * Renders a {@link StepBadge} only during a first-time login setup.
 *
 * Whether the user is first-time vs. returning is derived from the session
 * `mfaToken` ({@link useIsFirstTimeLogin}). Renders nothing for returning
 * users, so the badge never shows on a returning sign-in.
 */
export function FirstTimeStepBadge({ step }: FirstTimeStepBadgeProps) {
  const isFirstTime = useIsFirstTimeLogin()

  if (!isFirstTime) return null

  return <StepBadge step={step} />
}
